import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { LogoMarquee } from "@/components/LogoMarquee";
import { Tools } from "@/components/Tools";
import { UseCases } from "@/components/UseCases";
import { Curriculum } from "@/components/Curriculum";
import { HowItWorks } from "@/components/HowItWorks";
import { Instructor } from "@/components/Instructor";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main>
        <Hero />
        <LogoMarquee />
        <Tools />
        <UseCases />
        <Curriculum />
        <HowItWorks />
        <Instructor />
        <Testimonials />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
